<div class="grid-container v-pad text-align-center">
  @if (!isLoggedIn && activatedRoute.params | async; as params) {
    <h2 class="margin-top-large">Authorization Required</h2>
    <p class="margin-top-large">The page you have requested requires you to <button class="linkButton" (click)="logIn(params.ref)">Log In</button>.</p>
  } @else {
    <h2 class="margin-top-large">Not Authorized</h2>
    <p class="margin-top-large">You do not have permission to view the page you have requested. Click <button class="linkButton" (click)="goBack()">here</button> to return to the previous page.</p>
  }
</div>
<confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
